import { render } from "./HeroiconsSolidDocumentAdd.vue?vue&type=template&id=a449a3c4"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocumentAdd.vue"]])

export default __exports__